import { render, staticRenderFns } from "./AccountDefaultsSettings.vue?vue&type=template&id=e9c7f780&scoped=true"
import script from "./AccountDefaultsSettings.vue?vue&type=script&lang=js"
export * from "./AccountDefaultsSettings.vue?vue&type=script&lang=js"
import style0 from "./AccountDefaultsSettings.vue?vue&type=style&index=0&id=e9c7f780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c7f780",
  null
  
)

export default component.exports